import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmployeeStandardSelectableUser } from '../../../../../../models/employee-standard-overrides.model';

@Component({
  selector: 'app-employee-standard-user-selector',
  templateUrl: './employee-standard-user-selector.component.html',
  styleUrls: ['./employee-standard-user-selector.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployeeStandardUserSelectorComponent {
  @Input() public users: EmployeeStandardSelectableUser[] = [];
  @Input() public selectedCount = 0;
  @Input() public isLoading = false;
  @Output() public readonly userToggled = new EventEmitter<EmployeeStandardSelectableUser>();
  @Output() public readonly selectionSubmitted = new EventEmitter<void>();

  public get hasUsers(): boolean {
    return this.users.length > 0;
  }

  public get canSubmit(): boolean {
    return !this.isLoading && this.selectedCount > 0;
  }

  public onToggleUser(user: EmployeeStandardSelectableUser): void {
    if (!user || !user.id) {
      return;
    }
    this.userToggled.emit(user);
  }

  public onSubmitSelection(): void {
    if (!this.canSubmit) {
      return;
    }
    this.selectionSubmitted.emit();
  }

  public trackByUser(index: number, user: EmployeeStandardSelectableUser): string {
    return user.id;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/employee-standard-overrides/employee-standard-user-selector/employee-standard-user-selector.component.ts